import { render, staticRenderFns } from "./JoszakiCard.vue?vue&type=template&id=d00767f4"
import script from "./JoszakiCard.vue?vue&type=script&lang=js"
export * from "./JoszakiCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports